import { BehaviorSubject, Observable } from 'rxjs';

import { ErrorInvalidSession } from 'src/app/_helpers/interfaces/IErrors';
import { IListPermisions } from 'src/app/_helpers/interfaces/generic.interface';
import { IUser } from '../../_helpers/interfaces/IUser';
import { Injectable } from '@angular/core';
import { LoginSsoService } from 'src/app/auth/login-sso/services/login-sso.service';
import { RequestService } from './request.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private currentSession = new BehaviorSubject({
    session     : false,
    username    : "",
    nombre      : "",
    access_token: "",
    expiration  : 0,
    path        : "",
    perfil      : "",
    sso         : false
	});

  private currentMenu = new BehaviorSubject<any[]>([])
  constructor(
    private req: RequestService,
    private router: Router,
    private loginSsoSrv : LoginSsoService
  ) { }

  iniciarSesion( username: string, vUser: string, tkOTP:string , tkSesion: string) : Observable<any> {
    return this.req.post( environment.http.auth.login, { token: tkSesion ?? tkOTP, password: vUser }, { ordServicio: environment.apiKeys.ordServicio } )
  }
  getSession() {
    let data : any
    if (localStorage.getItem(environment.localStorage.user)) {
      data = localStorage.getItem(environment.localStorage.user)
      if ( !environment.regex.base64.test( data ) ) {
        this.cerrarSesion()
      } else {
        return atob( data ) != null ? JSON.parse(atob( data )!) : null;
      }
    }
  }
  setUser( user: IUser ) {
    localStorage.setItem( environment.localStorage.user, btoa( JSON.stringify(user) ) );
    this.currentSession.next( user );
  }
  getUser(): IUser {
    return this.currentSession.value;
  }
  cerrarSesion() {
    if( !this.getUser().session ) return;
    this.closeSesion().subscribe({
      next: response => {
        if(!response.success) {
          throw new ErrorInvalidSession(
            'Cerrar Sesión',
            'error',
            response.mensaje ?? 'Lo sentimos, ocurrio un error al cerrar sesión'
          )
        }
        this.cleanUser();
      },
      error: err => {
        throw new ErrorInvalidSession(
          'Cerrar Sesión',
          'error',
          err.mensaje ?? 'Lo sentimos, ocurrio un error al cerrar sesión'
        )
      }
    })
  }

  cargarMenu() : Observable<any> {
    if(this.getUser().perfil == "Administrador"){
      return new Observable(observe => {
        observe.next({
          success:true,
          permisos: [
            {
              icono: 'dashboard',
              nombre: 'Dashboard',
              path: '/dashboard',
              secciones: []
            },
            {
              icono: 'supervisor_account',
              nombre: 'Distribuidores',
              path: '/distribuidores',
              secciones: []
            },{
              icono: 'fact_check',
              nombre: 'Solicitudes',
              path: '/solicitudes',
              secciones: []
            },
             {
              icono: 'assignment_ind',
              nombre: 'Gestión Soporte',
              path: '/gestion-soporte',
              secciones: []
            },
            {
              icono: 'sell',
              nombre: 'Ofertas',
              path: '/ofertas',
              secciones: []
            },
            {
              icono: 'sim_card',
              nombre: "Buscar SIM",
              path: '/buscar-sim',
              secciones: []
            },
            {
              icono : 'delete-tripleta',
              nombre: 'Solicitudes eliminación tripleta',
              path  : '/eliminacion-tripleta',
              secciones: []
            },
            {
              icono: 'format_list_bulleted',
              nombre: 'Reportes',
              path: '/reportes',
              secciones: [
                {
                  nombre: 'General',
                  path: ''
                },
                {
                  nombre: 'Portabilidad',
                  path: '/portabilidades'
                }
              ]
            }
          ]
        })
      })
    }else if(this.getUser().perfil == "Soporte"){
      return new Observable(observe => {
        observe.next({
          success:true,
          permisos: [
            {
              icono: 'sim_card',
              nombre: 'Buscar SIM',
              path: '/buscar-sim',
              secciones: []
            },
            {
              icono: 'format_list_bulleted',
              nombre: 'Reportes',
              path: '/reportes',
              secciones: [
                {
                  nombre: 'Portabilidad',
                  path: '/portabilidades'
                }
              ]
            }
          ]
        })
      })
    }else{
      return this.req.get( environment.http.auth.menu, '' )
    }
  }
  setMenu( menu: any[] ) {
    localStorage.setItem( environment.localStorage.menu, JSON.stringify(menu) );
    this.currentMenu.next( menu );
  }

  getMenu() : any[] {
    if( localStorage.getItem(environment.localStorage.menu) != null ) {
      const menu = JSON.parse(localStorage.getItem(environment.localStorage.menu)!)
      this.setMenu(menu ?? []);
      return this.currentMenu.value
    }else{
      return []
    }
  }

  // formatMenu(data : IListPermisions[]) : IListPermisions[] {
  //   return data.map(e => {
  //     return {
  //       ...e
  //     }
  //   })
  // }

  mediosPublicidad(): Observable<any>{
    return this.req.get( environment.http.listadoMediosPublicidad, '' )
  }
  redesSociales(): Observable<any>{
    return this.req.get( environment.http.listadoRedesSociales, '' )
  }
  preregistro(
    tk: string,
    datosGeneralesTipoPersona:any,
    datosGeneralesNombre:any,
    datosGeneralesRfc:any,
    datosGeneralesCalle:any,
    datosGeneralesColonia:any,
    datosGeneralesNoExterior:any,
    datosGeneralesNoInterior:any,
    datosGeneralesDeudorWalmart:any,
    datosGeneralesRepresentanteLegalNombre:any,
    datosGeneralesRepresentanteLegalCorreo:any,
    datosGeneralesRepresentanteLegalTelefono:any,
    datosGeneralesRepresentanteLegalCalle:any,
    datosGeneralesRepresentanteLegalNoExterior:any,
    datosGeneralesRepresentanteLegalNoInterior:any,
    datosGeneralesRepresentanteLegalColonia:any,
    datosGeneralesContactoComercial:boolean,
    datosGeneralesContactoComercialNombre:any,
    datosGeneralesContactoComercialCorreo:any,
    datosGeneralesContactoComercialTelefono:any,
    datosGeneralesContactoComercialCalle:any,
    datosGeneralesContactoComercialNoExterior:any,
    datosGeneralesContactoComercialNoInterior:any,
    datosGeneralesContactoComercialColonia:any,
    // experienciaConsumoMensual:any,
    experienciaMediosPublicidad:any,
    experienciaRedes:any,
    experienciaCiudadesDistribucion:any,
    acta:any,
    rfc:any,
    fiscal:any,
    compDomicilio:any,
    identOficRepLegal:any,
    identOficialContactComercial:any,
    aceptoDatosVeridicos:any
  ) : Observable<any> {
    return this.req.post( environment.http.preregistro, {
      "registro":{
        tokenCorreo: tk,
        "datosGenerales":{
            "tipoPersona": datosGeneralesTipoPersona,
            "nombre": datosGeneralesNombre,
            "rfc": datosGeneralesRfc,
            "calle": datosGeneralesCalle,
            "colonia": datosGeneralesColonia,
            "exterior": datosGeneralesNoExterior,
            "interior": datosGeneralesNoInterior,
            "numeroDeudor": datosGeneralesDeudorWalmart
        },
        "datosRepresentante": {
            "nombre": datosGeneralesRepresentanteLegalNombre,
            "correo": datosGeneralesRepresentanteLegalCorreo,
            "telefono": datosGeneralesRepresentanteLegalTelefono,
            "calle": datosGeneralesRepresentanteLegalCalle,
            "exterior": datosGeneralesRepresentanteLegalNoExterior,
            "interior": datosGeneralesRepresentanteLegalNoInterior,
            "colonia": datosGeneralesRepresentanteLegalColonia
        },
        "datosContacto": {
            "mismaInformacionRepre": datosGeneralesContactoComercial,
            "nombre": datosGeneralesContactoComercialNombre,
            "correo": datosGeneralesContactoComercialCorreo,
            "telefono": datosGeneralesContactoComercialTelefono,
            "calle": datosGeneralesContactoComercialCalle,
            "exterior": datosGeneralesContactoComercialNoExterior,
            "interior": datosGeneralesContactoComercialNoInterior,
            "colonia": datosGeneralesContactoComercialColonia
        },
        "experienciaDistribuidor":{
            "mediosPublicidad": experienciaMediosPublicidad,
            "redesSociales": experienciaRedes,
            "municipios": experienciaCiudadesDistribucion,
        },
        "documentos":{
            "actaConstitutiva": acta,
            "rfc": rfc,
            "constanciaFiscal": fiscal,
            "comprobanteDomicilio": compDomicilio,
            "identificacionOficialRepresentante": identOficRepLegal,
            "identificacionOficialComercial": identOficialContactComercial
        },
        "informacionVeridica": aceptoDatosVeridicos
      }
    })
  }

  recuperarvUser(username:string): Observable <any>{
    return this.req.post( environment.http.auth.recuperacion.solicitud, {
      "solicitud":{
        "correo": username
      }
      }, { ordServicio: environment.apiKeys.ordServicio, ordOrigin: "ordenaris.distribuidores.com" })
  }

  cambiarvUserRecuperar(vUser2:string, token:string) : Observable<any>{
    return this.req.post( environment.http.auth.recuperacion.cambiovUser.replace(":token:", token), {"contrasena": vUser2}, { ordServicio: environment.apiKeys.ordServicio, ordOrigin: "ordenaris.distribuidores.com" } )
  }

  activarCuenta( vUser2: string, tk: string ) : Observable<any> {
    return this.req.post(
      environment.http.auth.recuperacion.activarCuenta.replace(":token:", tk),
      {
        "password": vUser2
      },{
        ordServicio: environment.apiKeys.ordServicio
      }
    )
  }

  sesionSSO() : Observable<any> {
    return this.req.get(
      environment.http.auth.sso.api.urlLoginSSO,'',{
        ordServicio: environment.apiKeys.ordServicio
      }
    )
  }

  deleteAccessToken(refreshToken : string){
    this.loginSsoSrv.revocationEndPoint(refreshToken).subscribe({
      error: err => {
        throw new ErrorInvalidSession(
          err.error ??'Cerrar Sesión SSO',
          'error',
          err.error_description ?? 'Lo sentimos, ocurrio un error al cerrar sesión SSO'
        )
      }
    })
    this.cleanUser();
  }

  closeSesion() : Observable<any> {
    return this.req.get(
      environment.http.auth.cerrarSesion, ''
    )
  }

  cleanUser() : void {
    localStorage.removeItem(environment.localStorage.user);
    localStorage.removeItem(environment.localStorage.menu);
    this.setUser({
      session     : false,
      username    : "",
      nombre      : "",
      access_token: "",
      expiration  : 0,
      path        : "",
      perfil      : "",
      sso         : false
    });
    this.router.navigate(["auth"]);
  }

}
